module.exports = __webpack_public_path__ + "img/loader.5ee17115.gif";